import React, {useContext, useEffect} from 'react'
import {AppbarContentContext} from "../../routing/appbar/AppbarContentProvider";
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";

const HelpSection = () => {
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: 'Help',
            description: 'If the application is not intuitive enough...',
            actions: <>
            </>
        })
    }, [])

    return (
        <div>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore/>} id="trailer-header">
                    <Typography variant="h4">JudgED - Trailer</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <iframe title="trailer" src="https://player.vimeo.com/video/1196315166?h=80c80e96c4" width="640" height="360"
                            frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMore/>} id="explainer-header">
                    <Typography variant="h4">JudgED - Explained</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div>
                        <iframe title="explainer-uploadVideo" src="https://player.vimeo.com/video/1196314011?h=e9329d42e1" width="640" height="360"
                                frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                    </div>

                    <div>
                        <iframe title="explainer-createScoredScene" src="https://player.vimeo.com/video/1196314430?h=30bb1647c5" width="640" height="360"
                                frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                    </div>

                    <div>
                        <iframe title="explainer-addHighlighting" src="https://player.vimeo.com/video/1196314658?h=260ff064eb" width="640" height="360"
                                frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                    </div>

                    <div>
                        <iframe title="explainer-addBlurring" src="https://player.vimeo.com/video/1196314893?h=bd27868a46" width="640" height="360"
                                frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

export default HelpSection
